module.exports = __webpack_public_path__ + "assets/img/2022_02.38bd756b.png";